import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Fa from 'react-fontawesome';
import { toast } from 'react-toastify';
import Helmet from 'react-helmet';
import { Element, scroller } from 'react-scroll';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { List, WindowScroller, AutoSizer, CellMeasurerCache, CellMeasurer } from 'react-virtualized';
import StickyBox from 'react-sticky-box';
import { find, findIndex, first, delay, map, filter, orderBy, range, each, concat, capitalize, debounce, indexOf, reduce } from 'lodash';
import BodyClassName from 'react-body-classname';
import SearchForm from '../../../../components/search-form';
import { getHasNoDecisionSetup } from '../../../../components/search-form/search-form-reducer';
import InsightModal from '../../components/sidebox/InsightModal';
import SubNav from '../../components/nav';
import SideBox from '../../components/sidebox';
import SearchField from '../../../../components/search-field';
import OpportunityBox from '../../components/opportunity-box';
import Shimmer from '../../components/opportunity-box/Shimmer';
import RequiredTVCollectorMappingSetup from '../../../Setup/pages/TruVoiceCollectorsPage/RequiredTVCollectorMappingSetup';
import OutreachPlanModal from '../../components/outreach-plan-modal';
import EditSenderModal from '../../components/edit-sender-modal';
import CommunicationRecipientModal from '../../components/communication-recipient';
import EditLanguageModal from '../../components/edit-language-modal';
import SellerFeedbackModal from '../../components/seller-feedback-modal';
import SellerAttributeModal from '../../components/seller-attribute-modal';
import ExcludeOpportunityForm from '../../components/opportunity-box/ExcludeOpportunityForm';
import OpportunityModal from '../../../Dashboard/components/WinLossOpportunityTable/modal';
import CancelOutreachForm from '../../components/opportunity-box/CancelOutReachForm';
import RequestFeedbackManager from '../../../../components/request-feedback-manager';
import ColumnDataManager from '../../../../components/god-table/column-data-manager';
import AutomationTestModal from '../../../Setup/pages/DiscoveryBotPage/AutomationTestModal';
import IncludeOpenOpportunities from '../../components/include-open-opportunities';
import NumberDisplay from '../../../../components/number-display';
import { getColumnData } from '../../../../components/god-table/reducer';
import { fetchColumnsData } from '../../../../components/god-table/actions';
import { getHeaderHeight, getFooterHeight, getWindowWidth } from '../../../App/AppReducer';
import ProgessBar from '../../../../components/progress-bar';

import { fetchPrograms } from '../../../Nomination/NominationActions';
import { getPrograms } from '../../../Nomination/NominationReducer';
import { 
  resetOpportunityAutomationSettings,
  sendSummaryEmail,
  sendReminderEmail,
} from '../../../Setup/SetupActions';
import {
  fetchTVProductMappings,
  fetchAllAutomationEmails,
} from '../../../Setup/SetupActions';

import {
  getUser,
  getUserCurrentOrganization,
  getCanSetupOrganization,
} from '../../../Auth/AuthReducer';

import {
  resetAll,
  fetchFeedbackOpportunities,
  fetchInsights,
  requestEditWinLossOpportunityFeedbacks,
  winLossExcludeOpportunity,
  winLossIncludeOpportunity,
  fetchCollectorStats,
  loadSettings,
  winLossCancelSurveys,
  fetchWinLossOpportunitySurveys,
  fetchOpportunityRequestStatus,
  updateReminderEmailStatus,
  appendOpportunityContactRole,
} from '../../../Dashboard/DashboardActions';

import {
  getWinLossLoading,
  getWinLossLoaded,
  getWinLossOpportunities,
  getWinLossFeedbackLoaded,
  getWinLossCollectorStats,
  getWinLossErrors,
  getFeedbackRequestSettings,
} from '../../../Dashboard/DashboardReducer';

import styles from './styles.css';


const sortOptions = [
  {
    label: 'CLOSE DATE', value: 'close_date', isHeader: true,
  },
  {
    label: 'Newest First', longLabel: 'Close Date, Newest', value: 'close_date_desc', sortKey: 'close_date', sortDir: 'desc',
  },
  {
    label: 'Oldest First', longLabel: 'Close Date, Oldest', value: 'close_date_asc', sortKey: 'close_date', sortDir: 'asc',
  },

  {
    label: 'FEEDBACK DATE', value: 'feedback_date', isHeader: true,
  },
  {
    label: 'Newest First', longLabel: 'Feedback Date, Newest', value: 'feedback_date_desc', sortKey: 'max_feedback_date', sortDir: 'desc',
  },
  {
    label: 'Oldest First', longLabel: 'Feedback Date, Oldest', value: 'feedback_date_asc', sortKey: 'min_feedback_date', sortDir: 'asc',
  },

  {
    label: 'REQUEST DATE', value: 'request_date', isHeader: true,
  },
  {
    label: 'Newest First', longLabel: 'Request Date, Newest', value: 'request_date_desc', sortKey: 'max_request_date', sortDir: 'desc',
  },
  {
    label: 'Oldest First', longLabel: 'Request Date, Oldest', value: 'request_date_asc', sortKey: 'min_request_date', sortDir: 'asc',
  },

  {
    label: 'DEAL SIZE', value: 'deal_size', isHeader: true,
  },
  {
    label: 'Largest First', longLabel: 'Deal Size, Descending', value: 'amount_desc', sortKey: 'amount', sortDir: 'desc', icon: 'sort-numeric-desc',
  },
  {
    label: 'Smallest First', longLabel: 'Deal Size, Ascending', value: 'amount_asc', sortKey: 'amount', sortDir: 'asc', icon: 'sort-numeric-asc',
  },

  {
    label: 'ACCOUNT NAME', value: 'account_name', isHeader: true,
  },
  {
    label: 'Ascending', longLabel: 'Account Name, Ascending', value: 'account_asc', sortKey: 'account.name', sortDir: 'asc', icon: 'sort-alpha-asc',
  },
  {
    label: 'Descending', longLabel: 'Account Name, Descending', value: 'account_desc', sortKey: 'account.name', sortDir: 'desc', icon: 'sort-alpha-desc',
  },
];
const filterOptions = [
  {
    label: 'Closed Deals', value: null, filters: { excluded: false },
  },
  {
    label: 'Closed & Excluded', value: 'all', filters: null,
  },
  {
    label: 'Have Feedback', value: 'have_feedback', filters: { has_feedbacks: true },
  },
  {
    label: 'Need Feedback', value: 'need_feedback', filters: { need_reasons: true, has_requests: false, excluded: false },
  },
  {
    label: 'Requesting Feedback', value: 'requesting_feedback', filters: { in_outreach: true },
  },
  {
    label: 'Excluded Deals', value: 'excluded_deals', filters: { excluded: true },
  },
  {
    label: 'Have Seller Feedback', value: 'have_seller_feedback', filters: { has_seller_feedback: true, excluded: false },
  },
  {
    label: 'Need Seller Feedback', value: 'need_seller_feedback', filters: { has_seller_feedback: false, excluded: false },
  },
];

const includeResources = ['accounts', 'owners', 'accountWebsite', 'contactRoles', 'accountContactCount', 'lineItems', 'accountIndustries', 'internalEmailCount'];

const LIMIT_CHARS = 3;

class DecisionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      query: null,
      tabs: {},
      colorPalletes: {},
      selectedFilter: null,
      selectedSort: 'close_date_desc', // default
      opportunities: [],
      currentSurveyPlan: null,
      currentEditSenderSurvey: null,
      currentEditCommnunicationRecipient: null,
      currentEditLanguageSurvey: null,
      changeLanguageCallback: null,
      currentOpportunityForSellerFeedback: null,
      currentSurveySellerAttibute: null,
      currentlyExcludedOpportunity: null,
      selectedOpportunityIds: [],
      selectedLanguage: null,
      availableLanguages: [],
      currentCancelContact: null,
      currentCancelContactObject: null,
      cancelContactCallBack: null,
      showExcluedReason: false,
      showTestModal: false,
      testOwnerId: null,
      testOpportunityId: null,
      testAutomationId: null,
      backendQuickSearching: false,
      hasBackendResults: false,
      searchId: 0,
      overscanStartIndex: 0,
      overscanStopIndex: 0,
      priorityData: [],
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.rowRenderer = this.rowRenderer.bind(this);
    this.handleSearch = debounce(this.handleSearch.bind(this), 500, {});
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleOnAccountLogoLoaded = this.handleOnAccountLogoLoaded.bind(this);
    this.keyMapper = this.keyMapper.bind(this);
    this.handleRequestShowInsight = this.handleRequestShowInsight.bind(this);
    this.handleSelectSortOption = this.handleSelectSortOption.bind(this);
    this.handleSelectFilterOption = this.handleSelectFilterOption.bind(this);
    this.handleRequestAddOpportunitySurvey = this.handleRequestAddOpportunitySurvey.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.handleOnSubmitContacts = this.handleOnSubmitContacts.bind(this);
    this.handleSubmitContactAndDone = this.handleSubmitContactAndDone.bind(this);
    this.handleExcludeOpportunity = this.handleExcludeOpportunity.bind(this);
    this.requestExcludeOpportunity = this.requestExcludeOpportunity.bind(this);
    this.handleIncludeOpportunity = this.handleIncludeOpportunity.bind(this);
    this.handleRequestShowOutreachPlan = this.handleRequestShowOutreachPlan.bind(this);
    this.handleRequestFetchCollectorStats = this.handleRequestFetchCollectorStats.bind(this);
    this.requestChangeSenderEmail = this.requestChangeSenderEmail.bind(this);
    this.requestChangeCommnunicationRecipient = this.requestChangeCommnunicationRecipient.bind(this);
    this.requestChangeLanguage = this.requestChangeLanguage.bind(this);
    this.handleRequestCancel = this.handleRequestCancel.bind(this);
    this.handleRequestAddSellerFeedback = this.handleRequestAddSellerFeedback.bind(this);
    this.handleRequestShowSellerAttribute = this.handleRequestShowSellerAttribute.bind(this);
    this.showOpportunities = this.showOpportunities.bind(this);
    this.handleCancelOutreach = this.handleCancelOutreach.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
    this.handleRequestRunTest = this.handleRequestRunTest.bind(this);
    this.hideTestModal = this.hideTestModal.bind(this);
    this.handleExtraDataLoaded = this.handleExtraDataLoaded.bind(this);
    this.handleRequestSendSummaryEmail = this.handleRequestSendSummaryEmail.bind(this);
    this.handleRequestSendReminderEmail = this.handleRequestSendReminderEmail.bind(this);
    this.handleRequestPauseReminderEmail = this.handleRequestPauseReminderEmail.bind(this);
    this.extendSearch = this.extendSearch.bind(this);
    this.handleContactAdded = this.handleContactAdded.bind(this);
    
    this.cache = new CellMeasurerCache({
      defaultHeight: 500,
      minHeight: 250,
      fixedWidth: true,
      keyMapper: this.keyMapper,
    });
  }

  componentDidMount() {
    this.props.dispatch(resetAll(false));
    Promise.all([
      this.props.dispatch(fetchTVProductMappings()),
      this.props.dispatch(fetchPrograms()),
      this.props.dispatch(resetOpportunityAutomationSettings()),
    ])
      .then(
        (response) => {
          this.setState({ loading: false });
        },
        () => {
          this.setState({ loading: false });
        },
      );
  }


  componentWillReceiveProps(nextProps) {
    const shouldLoad = (!this.props.winLossLoaded && nextProps.winLossLoaded) ||
      (!this.props.feedbackLoaded && nextProps.feedbackLoaded);
    if (shouldLoad) {
      this.refreshData(nextProps.opportunities);
    }
  }

  handleExtraDataLoaded() {
    this.refreshData();
  }

  scrollToTop() {
    scroller.scrollTo('feedbackTop', { duration: 1000, smooth: true, offset: -100 });
  }

  getActiveSortOption() {
    const { selectedSort } = this.state;
    return find(sortOptions, { value: selectedSort || 'close_date_desc' }) || first(sortOptions);
  }

  getActiveFilterOption() {
    const { selectedFilter } = this.state;
    return find(filterOptions, { value: selectedFilter }) || first(filterOptions);
  }

  handleRequestRunTest(opportunity, automationId = null) {
    this.setState({ showTestModal: true, testOwnerId: opportunity.owner_id, testOpportunityId: opportunity.opportunity_id, testAutomationId: automationId });
  }

  handleSendEmail(type, opportunity, automationId) {
    let toastId = null;
    const toasterClose = () => {
      toastId = null;
    }
    const el = (
      <div><Fa name="spinner" spin /> Sending {type} email for <strong>{opportunity.name}</strong>...</div>
    );

    toastId = this.context.addNotification(el, { type: 'warning', autoClose: false, onClose: toasterClose });
    const action = type === 'reminder' ? sendReminderEmail : sendSummaryEmail;
    this.props.dispatch(action(automationId, opportunity.opportunity_id))
      .then(
        (result) => {
          const hasError = result.error === true;
          const el = hasError ? 
              (<div>{result.message}. A {type} email has not been sent for <strong>{opportunity.name}</strong></div>) :
              (<div>{capitalize(type)} email has been sent for <strong>{opportunity.name}</strong></div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: hasError ? 'error' : 'success',
              autoClose: !hasError,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: hasError ? 'error' : 'success', autoClose: true, onClose: toasterClose });
          }
        },
        (e) => {
          const el = (<div>{(e.data?.message || e.message)}</div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: 'error',
              autoClose: false,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: 'error', autoClose: true, onClose: toasterClose });
          }
        }
      );
  }

  handleContactAdded(object, contact, isAccount) {
    const { columnData } = this.props;
    const keyField = isAccount ? 'account_id' : 'opportunity_id';
    const objId = object[keyField];

    const oppData = columnData[objId];
    if (oppData) {
      const columnIds = reduce(oppData, (items, v, k) => {
        if (indexOf(['_id', keyField, '$loading'], k) < 0) {
          items.push(k);
        }
        return items;
      }, []); 
      this.props.dispatch(appendOpportunityContactRole(object, contact));
      this.props.dispatch(fetchColumnsData(columnIds, [objId], isAccount ? ColumnDataManager.RESOURCE_TYPE.ACCOUNT : ColumnDataManager.RESOURCE_TYPE.OPPORTUNITY, true))
        .then(
          () => {
            this.refreshData();
          }
        );
    }
  }

  handleToggleShowAIPeople(opportunity) {
    console.clear();
    console.log('opportunity', opportunity)
  }

  handleRequestSendReminderEmail(opportunity, automationId = null) {
    this.handleSendEmail('reminder', opportunity, automationId);
  }

  handleRequestPauseReminderEmail(opportunity, pause = false) {
    const p = this.props.dispatch(updateReminderEmailStatus(opportunity.opportunity_id, pause, false));
    let toastId = null;
    const toasterClose = () => {
      toastId = null;
    }
    const el = (
      <div><Fa name="spinner" spin /> {pause ? 'Pause' : 'Resume'} reminder email...</div>
    );
    toastId = this.context.addNotification(el, { type: 'warning', autoClose: false, onClose: toasterClose });
    p.then(
        (result) => {
          const el = (<div>Reminder email has been {result.disabled ? 'paused' : 'resumed'} for <strong>{opportunity.name}</strong></div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: 'success',
              autoClose: true,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: 'success', autoClose: true, onClose: toasterClose });
          }
        },
        (e) => {
          const el = (<div>{(e.data?.message || e.message)}</div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: 'error',
              autoClose: false,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: 'error', autoClose: true, onClose: toasterClose });
          }
        }
      );
    return p;
  }

  handleRequestSendSummaryEmail(opportunity, automationId = null) {
    this.handleSendEmail('summary', opportunity, automationId);
  }

  hideTestModal() {
    this.setState({ showTestModal: false }, () => {
      this.setState({
        testOwnerId: null,
        testOpportunityId: null,
      });
    });
  }

  getMatchedReasons(re, feedbacks) {
    return filter(feedbacks, (feedback) => {
      let matchCompetitor = false;
      let matchReason = false;
      let matchContact = false;
      let matchClassification = false;
      const isClient = feedback.is_client;
      if (isClient) {
        const contactName = feedback.contact_name || '';
        const label = feedback.label || '';
        const classification = feedback.classification_text || '';
        matchReason = label.match(re);
        matchContact = contactName.match(re);
        matchClassification = classification.match(re);
      } else {
        const competitor = feedback.vendor_name || '';
        matchCompetitor = competitor.match(re);
      }
      return matchCompetitor || matchReason || matchContact || matchClassification;
    });
  }

  getMatchedOpportunities(opportunities) {
    const { query } = this.state;
    const { columnData } = this.props;
    let items = opportunities;

    if (query && query.length) {
      const re = new RegExp(query, 'i');
      items = filter(items, (o) => {
        let matchName = false;
        let matchAccount = false;
        let matchStage = false;
        let matchOwner = false;
        let matchFeedbacks = false;
        let matchMeta = false;
        let matchQuickSearch = false;
        if (re) {
          const name = o.name || '';
          const stage = o.stage || '';
          const owner = o.owner || {};
          const ownerName = owner.name || '';
          const account = o.account || {};
          const accountName = account.name || '';

          matchName = name.match(re);
          matchStage = stage.match(re);
          matchAccount = accountName.match(re);
          matchOwner = ownerName.match(re);
          matchQuickSearch = `${(o.quickSearchString || '')}`.match(re);
     
          const md = columnData[o.opportunity_id] || {};
          each(md, (m) => {
            if (`${m}`.match(re) || m === query) {
              matchMeta = true;
            }
          });
          if (o.feedbacks && o.feedbacks.length) {
            matchFeedbacks = this.getMatchedReasons(re, o.feedbacks).length > 0;
          }
        }
        return matchQuickSearch || matchName || matchAccount || matchStage || matchOwner || matchFeedbacks || matchMeta;
      });
    }
    return items;
  }

  getFilteredOpportunities(opportunities) {
    const sortOption = this.getActiveSortOption();
    const filterOption = this.getActiveFilterOption();
    let items = opportunities;
    if (filterOption.filters) {
      items = filter(items, filterOption.filters);
    }
    items = this.getMatchedOpportunities(items);
    const { sortKey, sortDir } = sortOption;
    items = orderBy(items, [sortKey], [sortDir]);
    return items;
  }

  keyMapper(index) {
    const { opportunities } = this.props;
    const opportunity = opportunities[index];
    return opportunity?.opportunity_id;
  }

  handleTabSelect(opportunityId, tab, cb) {
    this.setState({ tabs: { ...this.state.tabs, [opportunityId]: tab } }, cb);
  }

  handleOnAccountLogoLoaded(opportunityId, accountLogoUrl, colorPallete, cb) {
    this.setState({ colorPalletes: { ...this.state.colorPalletes, [opportunityId]: colorPallete } }, cb);
  }

  handleRequestShowInsight(opportunityId, insightId) {
    this.props.dispatch(fetchInsights(opportunityId, insightId));
  }

  handleRequestAddOpportunitySurvey(opportunity, contact) {
    this.props.dispatch(requestEditWinLossOpportunityFeedbacks(opportunity, contact));
  }

  handleRequestAddSellerFeedback(opportunity) {
    this.setState({ currentOpportunityForSellerFeedback: opportunity });
  }

  handleRequestFetchCollectorStats(collector) {
    const { opportunities } = this.props;
    const ids = map(filter(opportunities, { has_requests: true }), 'opportunity_id');
    if (ids.length === 0) {
      ids.push(opportunities.length ? opportunities[0].opportunity_id : '');
    }
    this.props.dispatch(fetchCollectorStats(collector.collector_id, ids, false));
  }

  handleSelectSortOption(selectedSort) {
    this.setState({ selectedSort }, this.refreshData);
  }

  handleSelectFilterOption(selectedFilter) {
    this.setState({ selectedFilter }, this.refreshData);
  }

  handleOnSubmitContacts(opportunity /* feedbacks, surveys */) {
    const { opportunities } = this.state;
    const propOpportunities = this.props.opportunities;
    const id = opportunity.opportunity_id;
    const propOpportunity = find(propOpportunities, { opportunity_id: id });
    if (propOpportunity) {
      const indexed = findIndex(opportunities, { opportunity_id: id });
      if (indexed >= 0) {
        this.setState({ ...opportunities, [indexed]: opportunity }, this.refreshData);
      }
    }
  }

  handleSubmitContactAndDone(/* opportunity */) {
    // console.log('handleSubmitContactAndDone');
  }

  handleCancelOutreach(contact, reason) {
    const { currentCancelContactObject } = this.state;
    const isAccount = false;
    const contactId = contact.id;
    const collectorId = contact.collector_id;
    const id = currentCancelContactObject.opportunity_id;
    const p = this.props.dispatch(winLossCancelSurveys(collectorId, id, contactId, isAccount, reason, contact));
    p.then(
      (c) => {
        if (this.state.cancelContactCallBack) {
          this.state.cancelContactCallBack(c);
          this.setState({ cancelContactCallBack: null });
        }
      },
    );
    return p;
  }

  handleIncludeOpportunity(opportunity) {
    const p = this.props.dispatch(winLossIncludeOpportunity(opportunity.opportunity_id));
    p.then(() => {
      this.refreshData();
    });
    return p;
  }

  requestExcludeOpportunity(currentlyExcludedOpportunity) {
    this.handleRequestAddOpportunitySurvey(null);
    this.setState({ currentlyExcludedOpportunity });
  }

  handleExcludeOpportunity(opportunity, params) {
    const p = this.props.dispatch(winLossExcludeOpportunity(opportunity.opportunity_id, params));
    p.then(() => {
      this.props.dispatch(fetchWinLossOpportunitySurveys(opportunity.opportunity_id))
        .then(
          () => {
            this.refreshData();
          },
          () => {
            this.refreshData();
          },
        );
    });
    return p;
  }

  requestChangeSenderEmail(currentEditSenderSurvey) {
    this.setState({ currentEditSenderSurvey });
    return Promise.resolve();
  }

  requestChangeCommnunicationRecipient(currentEditCommnunicationRecipient) {
    this.setState({ currentEditCommnunicationRecipient });
    return Promise.resolve();
  }

  requestChangeLanguage(currentEditLanguageSurvey, selectedLanguage, availableLanguages, changeLanguageCallback = () => {}) {
    this.setState({
      currentEditLanguageSurvey,
      selectedLanguage,
      availableLanguages,
      changeLanguageCallback,
    });
    return Promise.resolve();
  }

  handleRequestCancel(currentCancelContact, currentCancelContactObject, cancelContactCallBack = () => {}) {
    this.setState({ currentCancelContact, currentCancelContactObject, cancelContactCallBack });
  }

  handleFormChange(criteria) {
    const { hasNoDecision } = this.props;  
    this.setState({ query: null, selectedFilter: null, backendQuickSearching: false, hasBackendResults: false });
    this.props.dispatch(resetAll(false))
      .then(() => {
        this.props.dispatch(loadSettings());
        this.setState({ tabs: {}, colorPalletes: {} });
  
        this.props.dispatch(fetchFeedbackOpportunities({ ...criteria }, hasNoDecision, includeResources))
          .then(
            ({ opportunities, total }) => {
              this.setState({ searchId: this.state.searchId + 1 });
              const returnResults = opportunities.length;
              const opportunityIds = opportunities.map(o => o.opportunity_id);
              this.props.dispatch(fetchOpportunityRequestStatus(opportunityIds, opportunityIds));
              if (total && total > returnResults) {
                const el = (
                  <div>
                    Your search return more than <NumberDisplay value={total} precision={0} suffix="result" suffixIsUnit /> .<br />
                    For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} suffix="result" suffixIsUnit /> will be displayed.
                  </div>
                );
                this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
              }
            },
            (e) => {
              let msg = null;
              if (e.data && e.data.message) {
                msg = e.data.message;
              } else if (e.statusText) {
                msg = e.statusText;
              }
              const el = (
                <div>
                  {msg}
                </div>
              );
              this.context.addNotification(el, { type: 'error', autoClose: false });
            },
          );
      });
  }

  handleReset() {
    this.props.dispatch(resetAll());
  }

  handleSearch(query) {
    this.setState({ query, hasBackendResults: false }, () => {
      if (query && query.length > 0) {
        const opportunities = this.getMatchedOpportunities(this.props.opportunities); // is there any match yet
        if (opportunities.length > 0 || query.length < LIMIT_CHARS) {
          // there is a match
          this.setState({
            priorityData: opportunities,
          }, () => {
            this.refreshData();
          });
        } else if (query.length >= LIMIT_CHARS) {
          this.refreshData(); // we need to refresh so the data display zero result and a loading bar
          this.performBackendQuickSearch();
        }
      } else if (!query || query.length === 0) {
        this.performBackendQuickSearch();
      }
    });
  }

  extendSearch(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.state.backendQuickSearching) {
      return;
    }
    if (this.state.query.length >= LIMIT_CHARS) {
      this.performBackendQuickSearch();
    }
  }

  performBackendQuickSearch() {
    if (this.state.backendQuickSearching) {
      return;
    }
    this.setState({ backendQuickSearching: true, priorityData: [] }, () => {
      const { hasNoDecision } = this.props;
      const empty = { query: { _id: 'ROOT', type: 'groupAND', values: [] } };
      this.props.dispatch(fetchFeedbackOpportunities({ q: this.state.query, query: empty }, hasNoDecision, includeResources, true))
        .then(
          ({ opportunities, total }) => {
            const opportunityIds = opportunities.map(o => o.opportunity_id);
            this.props.dispatch(fetchOpportunityRequestStatus(opportunityIds, opportunityIds));
            this.setState({ backendQuickSearching: false, hasBackendResults: true, priorityData: opportunities }, () => {
              this.refreshData();
            });
          },
          () => {

          }
        )
        .finally(() => {
        
        });
    });
  }

  refreshData(inputOpportunities = null) {
    const opportunities = this.getFilteredOpportunities(inputOpportunities || this.props.opportunities);
    this.setState({ opportunities }, () => {
      if (this.cache) {
        this.cache.clearAll();
      }
      delay(() => {
        if (this.list) {
          this.list.forceUpdateGrid();
        }
      }, 500);
    });
    return opportunities;
  }

  handleRequestShowOutreachPlan(currentSurveyPlan) {
    this.setState({ currentSurveyPlan });
    return Promise.resolve();
  }

  handleRequestShowSellerAttribute(attribute, reason, salesReps, opportunity) {
    this.setState({ currentSurveySellerAttibute: { attribute, reason, salesReps, opportunity } });
  }

  showOpportunities(selectedOpportunityIds, type, showExcluedReason = false) {
    this.setState({ selectedOpportunityIds, showExcluedReason });
  }

  rowRenderer({
    index, key, style, parent, isVisible, isScrolling,
  }) {
    const { tabs, colorPalletes } = this.state;
    const { collectorStats, auth, organization } = this.props;
    const { opportunities } = this.state;
    const opportunity = opportunities[index];
    const isLast = index === opportunities.length - 1;
    const id = opportunity.opportunity_id;
    return (
      <CellMeasurer
        cache={this.cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        {({ measure }) => {
          const shouldRenderSellerReasons = organization.seller_reasons_enabled && (organization.seller_reasons_public || opportunity.owner_id === auth.user_id);

          return (
            <div style={style}>
              <OpportunityBox
                auth={auth}
                isVisible={isVisible}
                opportunity={opportunity}
                collectorStats={collectorStats[id]}
                measure={measure}
                onTabSelect={(tab) => {
                  this.handleTabSelect(id, tab, measure);
                }}
                onLogoLoaded={(accountLogoUrl, colorPallete) => {
                  this.handleOnAccountLogoLoaded(id, accountLogoUrl, colorPallete, measure);
                }}
                requestShowInsight={(insightId) => {
                  this.handleRequestShowInsight(id, insightId);
                }}
                requestAddOpportunitySurvey={this.handleRequestAddOpportunitySurvey}
                requestAddSellerFeedback={this.handleRequestAddSellerFeedback}
                tab={tabs[id]}
                colorPallete={colorPalletes[id]}
                excludeOpportunity={this.requestExcludeOpportunity}
                includeOpportunity={this.handleIncludeOpportunity}
                requestShowOutreachPlan={this.handleRequestShowOutreachPlan}
                requestChangeSenderEmail={this.requestChangeSenderEmail}
                requestChangeCommnunicationRecipient={this.requestChangeCommnunicationRecipient}
                requestChangeLanguage={this.requestChangeLanguage}
                requestCancelContact={this.handleRequestCancel}
                isLast={isLast}
                sellerReasonsEnabled={shouldRenderSellerReasons}
                sellerReasonsFirst={organization.seller_reasons_first}
                emailAutomationsEnabled
                requestShowSellerAttribute={this.handleRequestShowSellerAttribute}
                requestRunTest={this.handleRequestRunTest}
                showRunTestButton={this.props.canSetupOrg}
                showSendSummaryEmailButton={this.props.canSetupOrg}
                requestSendSummaryEmail={this.handleRequestSendSummaryEmail}
                showSendReminderEmailButton={this.props.canSetupOrg}
                requestSendReminderEmail={this.handleRequestSendReminderEmail}
                requestPauseReminderEmail={this.handleRequestPauseReminderEmail}
                enableChangeCommnunicationRecipient
                isScrolling={isScrolling}
              />
            </div>
          );
      }}
      </CellMeasurer>
    );
  }

  renderFilterDropdown() {
    const activeOption = this.getActiveFilterOption();
    const { organization } = this.props;
    return (
      <span>
        Show:&nbsp;
        <DropdownButton
          onSelect={this.handleSelectFilterOption}
          bsSize="sm"
          title={activeOption ? activeOption.label : 'All Deals'}
          id="feedback-filters"
        >
          {filterOptions.map((option) => {
            const isSellerOption = option.value === 'have_seller_feedback' || option.value === 'need_seller_feedback';
            if (isSellerOption && !organization.seller_reasons_enabled) {
              return null;
            }
            return (
              <MenuItem
                active={activeOption && activeOption.value === option.value}
                key={option.value}
                eventKey={option.value}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </DropdownButton>
      </span>
    );
  }

  renderSortDropdown() {
    const activeOption = this.getActiveSortOption();
    const activeLabel = activeOption ? activeOption.longLabel : 'no sorting';
    return (
      <span>
        Sort by:&nbsp;
        <DropdownButton
          onSelect={this.handleSelectSortOption}
          bsSize="sm"
          title={activeLabel}
          id="feedback-sort"
        >
          {sortOptions.map((option) => {
            if (option.isHeader) {
              return (
                <MenuItem key={option.value} header>{option.label}</MenuItem>
              );
            }
            return (
              <MenuItem
                active={activeOption && activeOption.value === option.value}
                key={option.value}
                eventKey={option.value}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{option.label}
              </MenuItem>
            )
          })}
        </DropdownButton>
      </span>
    );
  }

  renderControls() {
    return (
      <div key="controls" className={styles.controls}>
        <nav key="controls" className="navbar navbar-default navbar-controls">
          <form className="navbar-form navbar-left">
            <SearchField onSearch={this.handleSearch} disabled={this.state.backendQuickSearching} />
          </form>
          <div className="navbar-form navbar-right">
            {this.renderFilterDropdown()}
            &nbsp;&nbsp;&nbsp;
            {this.renderSortDropdown()}
          </div>
        </nav>
      </div>
    );
  }

  renderBackendSearchController() {
    const { query, backendQuickSearching, hasBackendResults, opportunities } = this.state;
    const totalReturn = (opportunities || []).length;
    if (backendQuickSearching) {
      return null;
    }
    if (hasBackendResults) {
      if (totalReturn > 0) {
        return (
          <div className="alert alert-warning">The current search includes additional results from backend.</div>
        );
      }
      return null;
    }
    if (!query || query.length < LIMIT_CHARS) {
      return null;
    }
    return (
      <div className="alert alert-success" onClick={this.extendSearch}>You can also <a className="text-active" href=""><u>extend the current search results</u></a> to include backend data for <code>{query}</code>.</div>
    );
  }

  renderList() {
    const { opportunities, query, backendQuickSearching } = this.state;
    const totalReturn = (this.props.opportunities || []).length;
    const activeOption = this.getActiveFilterOption();

    const isSearching = (query && query.length > 0);

    return [
      this.renderControls(),
      ...(isSearching ? [this.renderBackendSearchController()] : []),
      (
        <AutoSizer key="sizer" disableHeight>
          {({ width }) => (
            <WindowScroller>
              {({ height, isScrolling, scrollTop }) => (
                <div>
                  <List
                    autoHeight
                    height={height}
                    ref={(ref) => { this.list = ref; }}
                    isScrolling={isScrolling}
                    rowCount={opportunities.length}
                    rowHeight={this.cache.rowHeight}
                    rowRenderer={this.rowRenderer}
                    scrollTop={scrollTop}
                    width={width}
                    overscanRowCount={15}
                  />
                  <div className={`${styles.scrollToTop} animated ${(scrollTop > 50 ? 'fadeIn' : 'fadeOut')}`}>
                    <a
                      href=""
                      onClick={(e) => { e.preventDefault(); this.scrollToTop(); }}
                    >
                      <Fa name="arrow-up" /> To Top
                    </a>
                  </div>
                </div>
              )}
            </WindowScroller>
          )}
        </AutoSizer>
      ),
      opportunities.length === 0 ? (
        <div key="warning" className="alert alert-warning" style={{ margin: '10px 3px' }}>
          {isSearching && 
            <div>
              {backendQuickSearching && 
                <div>
                  <p>One moment please. Performing a backend search for <code>{query}</code></p>
                  <ProgessBar />
                </div>
              }
              {!backendQuickSearching &&
                <div>
                  {query.length >= LIMIT_CHARS && <span>No results matching <code>{query}</code></span>}
                  {query.length < LIMIT_CHARS && <span>No results matching <code>{query}</code>. To perform a backend search, please type {LIMIT_CHARS} or more letters.</span>}
                </div>
              }
            </div>
          }
          {!isSearching &&
            <div>
              {totalReturn >= 0 &&
                <span>
                  Current search returns <NumberDisplay value={totalReturn} suffix="result" suffixIsUnit precision={0} />.
                  But no results matching active filter: {activeOption !== null && <strong>{activeOption.label}</strong>}.
                </span>
              }
              {totalReturn === 0 && <span>No results found.</span>}
            </div>
          }
        </div>
      ) : null,
      opportunities.length > 0 ? (
        <div key="credits" className={styles.credits}>
          <a target="_blank" rel="noopener noreferrer" href="https://clearbit.com">
            <img src="//logo.clearbit.com/clearbit.com" alt="Clearbit Logo" /> Logos provided by Clearbit
          </a>
        </div>
      ) : null,
    ];
  }

  renderSideNav(collectors = []) {
    const {
      headerHeight, footerHeight, windowWidth,
    } = this.props;
    const cls = styles.contentSidebar;
    const isMobile = windowWidth < 768 && windowWidth > 0;

    const inner = (
      <SideBox
        collectors={collectors}
        requestFetchCollectorStats={this.handleRequestFetchCollectorStats}
        requestShowObjects={this.showOpportunities}
      />
    );

    if (isMobile) {
      return (
        <div className={cls}>
          {inner}
        </div>
      );
    }
    return (
      <StickyBox offsetTop={headerHeight} offsetBottom={footerHeight} className={cls}>
        {inner}
      </StickyBox>
    );
  }

  renderShimmers() {
    return range(10).map(r => <Shimmer key={r} />);
  }

  renderContent(collectors = []) {
    const {
      winLossLoading, winLossLoaded, feedbackLoaded,
      auth,
    } = this.props;
    const { currentlyExcludedOpportunity } = this.state;
    const isLoading = !winLossLoaded || winLossLoading || !feedbackLoaded;
    if (!(!winLossLoaded || winLossLoading) && this.props.opportunities.length === 0) {
      return (
        <div className="alert alert-warning">
          No records found.
        </div>
      );
    }
    return (
      <div className={styles.content}>
        {this.renderSideNav(collectors)}
        <div className={styles.contentBody}>
          {isLoading && this.renderShimmers()}
          {!isLoading &&
            <div>
              <Element name="feedbackTop" />
              {this.renderList()}
              <SellerFeedbackModal
                opportunity={this.state.currentOpportunityForSellerFeedback}
                onClose={() => { this.setState({ currentOpportunityForSellerFeedback: null }); }}
                collectorTypes={['decision']}
                onSuccess={() => { this.refreshData(); }}
              />
              <OutreachPlanModal
                survey={this.state.currentSurveyPlan}
                onClose={() => { this.setState({ currentSurveyPlan: null }); }}
              />
              <EditSenderModal
                survey={this.state.currentEditSenderSurvey}
                onClose={() => { this.setState({ currentEditSenderSurvey: null }); }}
                onSuccess={() => { this.refreshData(); }}
              />
              <CommunicationRecipientModal
                object={this.state.currentEditCommnunicationRecipient}
                onClose={() => { this.setState({ currentEditCommnunicationRecipient: null }); }}
                onSuccess={() => { 
                  this.setState({ currentEditCommnunicationRecipient: null });
                  // this.refreshData(); 
                }}
              />
              <EditLanguageModal
                survey={this.state.currentEditLanguageSurvey}
                selectedLanguage={this.state.selectedLanguage}
                availableLanguages={this.state.availableLanguages}
                onClose={() => {
                  this.setState({
                    currentEditLanguageSurvey: null,
                    selectedLanguage: null,
                    availableLanguages: [],
                    changeLanguageCallback: null,
                  });
                }}
                onSuccess={(c) => {
                  this.refreshData();
                  if (this.state.changeLanguageCallback) {
                    this.state.changeLanguageCallback(c);
                    this.setState({ changeLanguageCallback: null });
                  }
                }}
              />
              <InsightModal />
              <SellerAttributeModal
                opportunity={(this.state.currentSurveySellerAttibute ? this.state.currentSurveySellerAttibute.opportunity : null)}
                salesReps={(this.state.currentSurveySellerAttibute ? this.state.currentSurveySellerAttibute.salesReps : null)}
                reason={(this.state.currentSurveySellerAttibute ? this.state.currentSurveySellerAttibute.reason : null)}
                attribute={(this.state.currentSurveySellerAttibute ? this.state.currentSurveySellerAttibute.attribute : null)}
                onClose={() => { this.setState({ currentSurveySellerAttibute: null }); }}
              />
              <ExcludeOpportunityForm
                opportunity={currentlyExcludedOpportunity}
                show={currentlyExcludedOpportunity !== null}
                onClose={() => { this.setState({ currentlyExcludedOpportunity: null }); }}
                requestExclude={this.handleExcludeOpportunity}
                auth={auth}
              />
              <OpportunityModal
                opportunityIds={this.state.selectedOpportunityIds}
                getOpportunities={getWinLossOpportunities}
                tableConfigs={{
                  isManager: true,
                  tableName: 'feedback-winloss-opportunities',
                }}
                onClose={() => {
                  this.setState({ selectedOpportunityIds: [] });
                }}
                showExcluedReason={this.state.showExcluedReason}
              />
              {this.state.currentCancelContact !== null &&
                <CancelOutreachForm
                  show
                  contact={this.state.currentCancelContact}
                  onClose={() => { this.setState({ currentCancelContact: null, currentCancelContactObject: null, cancelContactCallBack: null }); }}
                  onRequestCancel={this.handleCancelOutreach}
                />
              }
              <ColumnDataManager
                id="feedback-tile"
                key={this.state.searchId}
                getRowData={() => this.props.opportunities}
                resourceType="OPPORTUNITY"
                onColumnLoaded={this.handleExtraDataLoaded}
                forceLoadSystemColumnTags={['productDetails', 'contactDetails']}
                searchId={`${this.state.searchId}|${this.props.opportunities.length}`}
                priorityData={this.state.priorityData}
              />
            </div>
          }
        </div>
      </div>
    );
  }

  render() {
    const {
      winLossPrograms,
      winLossLoaded, winLossLoading,
      canSetupOrg,
      winLossErrors,
      feedbackRequestSettings,
    } = this.props;
    const {
      loading,
    } = this.state;
    const hasWinLoss = winLossPrograms.length > 0;
    const isLoading = !winLossLoaded || winLossLoading;
    const hasError = winLossErrors !== null;
    const includeOpenOpportunities = feedbackRequestSettings.include_open_opportunities === true;

    const topComponent = (
      <div className="clearfix">
        <div className="pull-left">
          <SubNav />
        </div>
        {!loading &&
          <div className="pull-right">
            <SearchForm
              onSearchChange={this.handleFormChange}
              onReset={this.handleReset}
              pullRight
              type="feedback/decisions"
              requireTeamSelector={false}
              selectDefaultTeam
              defaultCriteria={{
                type: 'groupAND',
                values: [
                  {
                    tag: 'closeDate',
                    type: 'include',
                    values: 'last-90-days',
                  },
                ],
              }}
              disabledFilters={[]}
              disabled={(isLoading && !hasError)}
            >
              {includeOpenOpportunities &&
                <IncludeOpenOpportunities
                  path={1}
                  level={1}
                  includeOpenOpportunities={includeOpenOpportunities}
                  showDelete={false}
                  showInclude={false}
                  searchCriteria={{
                    _id: 'open-opportunities',
                    type: 'include',
                    filter: {
                      _id: 'open-opportunities',
                      label: 'Open Opportunities',
                    },
                  }}
                />
              }
            </SearchForm>
          </div>
        }
      </div>
    );

    return (
      <div className={styles.body}>
        <Helmet title="Decisions | Feedback" />

        <BodyClassName className={styles.body} />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Libre+Baskerville:400,200i&display=swap" />
        <div className="container">
          <RequiredTVCollectorMappingSetup types={['decision']}>
            {(collectors) => {
              return (
                <div>
                  {topComponent}
                  <p />
                  {!hasWinLoss && !loading &&
                    <div className="alert alert-danger">
                      No Programs found.
                    </div>
                  }
                  {hasWinLoss && !loading && this.renderContent(collectors)}
                  {hasWinLoss && !loading &&
                    <RequestFeedbackManager
                      onSubmitContacts={this.handleOnSubmitContacts}
                      onSubmitContactAndDone={this.handleSubmitContactAndDone}
                      onSellerFeedbackSuccess={() => { this.refreshData(); }}
                      requestCancelContact={this.handleRequestCancel}
                      requestExcludeOpportunity={this.requestExcludeOpportunity}
                      onContactAdded={this.handleContactAdded}
                    />
                  }
                  {hasWinLoss && !loading && canSetupOrg &&
                    <AutomationTestModal
                      open={this.state.showTestModal}
                      onClose={this.hideTestModal}
                      ownerId={this.state.testOwnerId}
                      opportunityId={this.state.testOpportunityId}
                      automationId={this.state.testAutomationId}
                    />
                  }
                </div>
              );
            }}
          </RequiredTVCollectorMappingSetup>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const programs = getPrograms(state);
  const availablePrograms = ['Win Loss', 'Voice of the Buyer', 'Customer Experience'];
  let winLossPrograms = [];
  if (programs) {
    each(availablePrograms, (programType) => {
      if (programs[programType] && programs[programType].length) {
        winLossPrograms = concat(winLossPrograms, programs[programType]);
      }
    });
  }
  const auth = getUser(state);
  const userCurrentOrganization = getUserCurrentOrganization(state);
  return {
    winLossPrograms,
    auth,
    organization: userCurrentOrganization,
    winLossLoading: getWinLossLoading(state),
    winLossLoaded: getWinLossLoaded(state),
    winLossErrors: getWinLossErrors(state),
    opportunities: getWinLossOpportunities(state),
    hasNoDecision: getHasNoDecisionSetup(state),
    feedbackLoaded: getWinLossFeedbackLoaded(state),
    headerHeight: getHeaderHeight(state),
    footerHeight: getFooterHeight(state),
    windowWidth: getWindowWidth(state),
    collectorStats: getWinLossCollectorStats(state),
    canSetupOrg: getCanSetupOrganization(state),
    feedbackRequestSettings: getFeedbackRequestSettings(state),
    columnData: getColumnData(state),
  };
}

DecisionPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  winLossPrograms: PropTypes.arrayOf(PropTypes.shape({
    program_id: PropTypes.string,
    name: PropTypes.string,
    client_id: PropTypes.string,
  })),
  opportunities: PropTypes.arrayOf(PropTypes.shape({})),
  winLossLoading: PropTypes.bool,
  winLossLoaded: PropTypes.bool,
  winLossErrors: PropTypes.shape({}),
  hasNoDecision: PropTypes.bool,
  feedbackLoaded: PropTypes.bool,
  headerHeight: PropTypes.number,
  footerHeight: PropTypes.number,
  windowWidth: PropTypes.number,
  collectorStats: PropTypes.shape({}),
  auth: PropTypes.shape({}),
  canSetupOrg: PropTypes.bool,
  organization: PropTypes.shape({}),
  feedbackRequestSettings: PropTypes.shape({
    include_open_opportunities: PropTypes.bool,
  }),
  columnData: PropTypes.shape({}),
};

DecisionPage.defaultProps = {
  winLossPrograms: [],
  opportunities: [],
  winLossLoading: false,
  winLossLoaded: false,
  hasNoDecision: false,
  feedbackLoaded: false,
  winLossErrors: null,
  footerHeight: 0,
  headerHeight: 0,
  windowWidth: 0,
  collectorStats: {},
  auth: null,
  organization: null,
  rows: [],
  rowData: {},
  columnData: {},
  canSetupOrg: false,
  feedbackRequestSettings: {
    include_open_opportunities: false,
  },
};

DecisionPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(withRouter(DecisionPage));
